import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import LogInButton from 'flarum/forum/components/LogInButton';
import { redirectWithSsoOverlay } from './ssoRedirectOverlay';
function mainSiteBase() {
  const v = app.forum.attribute('umiteskiSsoMainSiteBaseUrl');
  return v && v.length > 0 ? v : undefined;
}
function mainSiteAccountUrl() {
  const v = app.forum.attribute('umiteskiSsoMainSiteAccountUrl');
  return v && v.length > 0 ? v : undefined;
}
function forumOAuthStartUrl() {
  const forumBase = app.forum.attribute('baseUrl');
  const path = window.location.pathname + window.location.search + window.location.hash;
  const returnTo = path || '/';
  return `${forumBase}/auth/umiteski?returnTo=${encodeURIComponent(returnTo)}`;
}

/** Kayıt: ana sitede oturum varsa register-bridge doğrudan istemci OAuth URL'sine gider; yoksa kayıt + return_to. */
function mainSiteRegisterUrl() {
  const base = mainSiteBase();
  return `${base}/sso/register-bridge?return_to=${encodeURIComponent(forumOAuthStartUrl())}`;
}

/**
 * Flarum 2: forum bileşenleri doğrudan import edilince runtime'da undefined olabiliyor.
 * String modül yolu + extend/override, flarum.reg.onLoad ile yükleme sonrası patch uygular.
 */
app.initializers.add('umiteski-sso/redirect-auth', () => {
  app.beforeMount(() => {
    const base = mainSiteBase();
    if (!base) {
      return;
    }
    override(LogInButton.prototype, 'initAttrs', function (original, attrs) {
      original.call(this, attrs);
      if (attrs.path !== '/auth/umiteski') {
        return;
      }
      attrs.onclick = event => {
        event.preventDefault();
        redirectWithSsoOverlay(forumOAuthStartUrl(), 'login');
      };
    });
    extend('flarum/forum/components/HeaderSecondary', 'items', function (items) {
      if (app.session.user) {
        return;
      }

      // umiteski-theme üst şeritten logIn kaldırıp alt şeride taşıyabiliyor; setContent yoksa anahtar yoktur.
      if (items.has('logIn')) {
        items.setContent('logIn', m(Button, {
          className: "Button Button--link",
          onclick: () => redirectWithSsoOverlay(forumOAuthStartUrl(), 'login')
        }, app.translator.trans('core.forum.header.log_in_link')));
      }
      if (items.has('signUp')) {
        items.setContent('signUp', m(Button, {
          className: "Button Button--link",
          onclick: () => redirectWithSsoOverlay(mainSiteRegisterUrl(), 'register')
        }, app.translator.trans('core.forum.header.sign_up_link')));
      } else {
        items.add('signUp', m(Button, {
          className: "Button Button--link",
          onclick: () => redirectWithSsoOverlay(mainSiteRegisterUrl(), 'register')
        }, app.translator.trans('core.forum.header.sign_up_link')), 10);
      }
    });

    // original mutlaka çalışmalı: üst Modal oninit animateShow vb. durumu kurar; atlanırsa oncreate patlar.
    override('flarum/forum/components/LogInModal', 'oninit', function (original) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const vnode = args[0];
      original(vnode);
      if (mainSiteBase()) {
        app.modal.close();
        redirectWithSsoOverlay(forumOAuthStartUrl(), 'login');
      }
    });
    override('flarum/forum/components/SignUpModal', 'oninit', function (original) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const vnode = args[0];
      const attrs = vnode.attrs;
      if (attrs?.token) {
        original(vnode);
        return;
      }
      original(vnode);
      if (mainSiteBase()) {
        app.modal.close();
        redirectWithSsoOverlay(mainSiteRegisterUrl(), 'register');
      }
    });
    const accountUrl = mainSiteAccountUrl();
    if (accountUrl) {
      extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
        if (items.has('changePassword')) {
          items.setContent('changePassword', m(Button, {
            className: "Button",
            onclick: () => window.location.assign(accountUrl)
          }, app.translator.trans('core.forum.settings.change_password_button')));
        }
        if (items.has('changeEmail')) {
          items.setContent('changeEmail', m(Button, {
            className: "Button",
            onclick: () => window.location.assign(accountUrl)
          }, app.translator.trans('core.forum.settings.change_email_button')));
        }
      });
      extend('flarum/common/components/EditUserModal', 'fields', function (items) {
        if (!app.session.user) {
          return;
        }
        const subject = this.attrs.user;
        if (String(subject.id()) !== String(app.session.user.id())) {
          return;
        }
        if (items.has('username')) {
          items.setContent('username', m("div", {
            className: "Form-group"
          }, m("label", null, app.translator.trans('core.lib.edit_user.username_heading')), m("p", {
            className: "helpText"
          }, app.translator.trans('umiteski-sso.forum.username_managed_on_main_site')), m(Button, {
            className: "Button Button--primary",
            onclick: () => window.location.assign(accountUrl)
          }, app.translator.trans('umiteski-sso.forum.open_main_site_account'))));
        }
      });
      override('flarum/forum/components/ChangePasswordModal', 'oninit', function (_original) {
        window.location.assign(accountUrl);
      });
      override('flarum/forum/components/ChangeEmailModal', 'oninit', function (_original) {
        window.location.assign(accountUrl);
      });
    }
  });
});